import Vue from 'vue'
import VueI18n from 'vue-i18n'
import pl from './pl'
import en from './en'

Vue.use(VueI18n)

const savedLocale = localStorage.getItem('adminLocale') || 'pl'
const isDev = process.env.NODE_ENV !== 'production'

// Synchronizacja <html lang> z językiem panelu. Bez tego strona ma lang="en"
// (z index.html) przy polskiej treści → przeglądarka auto-tłumaczy i marki
// (np. „Bolt") zamienia na słowa („śruba").
if (typeof document !== 'undefined') {
  document.documentElement.lang = savedLocale
}

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'pl',
  silentTranslationWarn: !isDev,
  silentFallbackWarn: !isDev,
  messages: { pl, en },
})

export default i18n
